<template>
  <div>
    <el-container class="layout-container">
      <el-main>
        <router-view :key="routeViewKey" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'LayoutWithoutMenu',
  computed: {
    routeViewKey() {
      // 服务平台公共布局保持同一实例，内部页面仍由其自己的 router-view 更新。
      return this.$route.matched.some(record => record.path === '/service') ? 'service' : this.$route.fullPath
    }
  },
}
</script>

<style lang="scss" scoped>
.layout-container {
  width: 100%;
  margin: auto;
  height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('@/static/images/service-icon/serviceBack.png');
  .el-main {
    padding: 0;
    overflow: hidden;
  }
}
</style>
